export default __webpack_public_path__ + "static/media/Card.870046af.png";